/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { WeightChangeCategoryDto } from './weightChangeCategoryDto';

export interface WeightReportLineDto {
  id?: string;
  schemaId?: string;
  clientLineId?: string;
  performedBy?: string;
  mainCategory?: WeightReportLineDto.MainCategoryEnum;
  areaTagSystem?: string;
  quantityMetres?: string;
  hoursSpent?: number;
  installedWeight?: number;
  removedWeight?: number;
  totalWeight?: number;
  changeFollowUpRequired?: boolean;
  description?: string;
  comment?: string;
  createdAt?: string;
  updatedAt?: string;
  selectedCategories?: Array<WeightChangeCategoryDto>;
}
export namespace WeightReportLineDto {
  export const MainCategoryEnum = {
    AdditionalWork: 'ADDITIONAL_WORK',
    WeightChange: 'WEIGHT_CHANGE',
    Other: 'OTHER',
  } as const;
  export type MainCategoryEnum = (typeof MainCategoryEnum)[keyof typeof MainCategoryEnum];
}
